export default __webpack_public_path__ + "static/media/digital.df9a4e25.jpg";